import HObject from '@/core/HObject.js'
import * as BABYLON from 'babylonjs'

export default class Land extends HObject {
  constructor (hObject) {
    super(hObject.name, hObject.type, hObject.allowRegistration)
    this.init(hObject)
  }

  register () {
    let hObject = this
    this.registered = true
    // LAND -TEST
    BABYLON.SceneLoader.ImportMesh('', 'static/assets/land/', 'land-test.babylon', window.scene, function (newMeshes, particleSystems) {
      // console.log('Preparando configuracion de ' + hApp.name)
      hObject.objectConfigurations(newMeshes)

      newMeshes[0].position.y = 0.08

      newMeshes[0].material = window.scene.getMaterialByName('materialTerreno')
      newMeshes[3].material = window.scene.getMaterialByName('materialSenderos')
      newMeshes[1].material = window.scene.getMaterialByName('materialCercaNatural')
      newMeshes[2].material = window.scene.getMaterialByName('materialCercaNatural')
    })

    // LAND - MUROS
    BABYLON.SceneLoader.ImportMesh('', 'static/assets/muros/', 'muros.babylon', window.scene, function (newMeshes, particleSystems) {
      var i
      hObject.objectConfigurations(newMeshes)
      hObject.lod(newMeshes, 500)

      for (i = 0; i < newMeshes.length; i++) {
        newMeshes[i].material = window.scene.getMaterialByName('materialMuros')
      }
    })

    // LAND - ENTRADAS MARCO
    BABYLON.SceneLoader.ImportMesh('', 'static/assets/muros/', 'entradas.babylon', window.scene, function (newMeshes, particleSystems) {
      var i
      hObject.objectConfigurations(newMeshes)
      hObject.lod(newMeshes, 500)
      for (i = 0; i < newMeshes.length; i++) {
        newMeshes[i].material = window.scene.getMaterialByName('materialEdificioX')
      }
    })

    // LAND - ENTRADAS PUERTAS
    BABYLON.SceneLoader.ImportMesh('', 'static/assets/muros/', 'entradas-puertas.babylon', window.scene, function (newMeshes, particleSystems) {
      var i
      hObject.objectConfigurations(newMeshes)
      hObject.lod(newMeshes, 100)

      for (i = 0; i < newMeshes.length; i++) {
        newMeshes[i].material = window.scene.getMaterialByName('materialPuerta')
      }
    })

    // LAND - ANDENES
    BABYLON.SceneLoader.ImportMesh('', 'static/assets/andenes/', 'andenes.babylon', window.scene, function (newMeshes, particleSystems) {
      var i
      hObject.objectConfigurations(newMeshes)
      hObject.lod(newMeshes, 500)

      for (i = 0; i < newMeshes.length; i++) {
        newMeshes[i].material = window.scene.getMaterialByName('materialSenderos')
      }
    })

    // LAND - ANDENES - INTERSECCIONES
    BABYLON.SceneLoader.ImportMesh('', 'static/assets/andenes/', 'intersecciones.babylon', window.scene, function (newMeshes, particleSystems) {
      var i
      hObject.objectConfigurations(newMeshes)
      hObject.lod(newMeshes, 500)

      for (i = 0; i < newMeshes.length; i++) {
        newMeshes[i].material = window.scene.getMaterialByName('materialIntersecciones')
      }
    })

    // LAND - BLOQUES
    BABYLON.SceneLoader.ImportMesh('', 'static/assets/bloques/', 'bloques.babylon', window.scene, function (newMeshes, particleSystems) {
      var i
      hObject.objectConfigurations(newMeshes)

      for (i = 0; i < newMeshes.length; i++) {
        newMeshes[i].material = window.scene.getMaterialByName('materialCristalesEdificio')
      }
    })

    BABYLON.SceneLoader.ImportMesh('', 'static/assets/bloques/', 'bloques1.babylon', window.scene, function (newMeshes, particleSystems) {
      var i
      hObject.objectConfigurations(newMeshes)

      for (i = 0; i < newMeshes.length; i++) {
        newMeshes[i].material = window.scene.getMaterialByName('materialCristalesEdificio1')
      }
      newMeshes[1].material = window.scene.getMaterialByName('materialEdificioX')
    })

    BABYLON.SceneLoader.ImportMesh('', 'static/assets/bloques/', 'bloques2.babylon', window.scene, function (newMeshes, particleSystems) {
      var i
      hObject.objectConfigurations(newMeshes)

      for (i = 0; i < newMeshes.length; i++) {
        newMeshes[i].material = window.scene.getMaterialByName('materialCristalesEdificio2')
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/hobjects/Land.js